import React from 'react';

const ROLFLogo = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="logoGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#184370" />
        <stop offset="100%" stopColor="#1e5a96" />
      </linearGradient>
      <linearGradient id="logoGrad2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4EB9BF" />
        <stop offset="100%" stopColor="#3a9da3" />
      </linearGradient>
    </defs>
    <circle cx="100" cy="100" r="95" fill="url(#logoGrad1)" />
    <circle cx="100" cy="100" r="82" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1" />
    <path d="M100 45 C75 45 55 65 55 90 C55 120 100 155 100 155 C100 155 145 120 145 90 C145 65 125 45 100 45Z" fill="url(#logoGrad2)" />
    <path d="M100 60 C82 60 68 74 68 92 C68 114 100 142 100 142 C100 142 132 114 132 92 C132 74 118 60 100 60Z" fill="rgba(255,255,255,0.25)" />
    <circle cx="88" cy="85" r="5" fill="white" opacity="0.9" />
    <circle cx="112" cy="85" r="5" fill="white" opacity="0.9" />
    <path d="M88 100 Q100 115 112 100" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.9" />
    <text x="100" y="185" textAnchor="middle" fill="white" fontSize="22" fontWeight="800" fontFamily="Inter, sans-serif" letterSpacing="6">ROLF</text>
  </svg>
);

export default ROLFLogo;
